{
  "title": "Hold Monster",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level enchantment",
  "level": 5,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S, M (a small, straight piece of iron)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "Choose a creature that you can see within range. The target must succeed on a Wisdom saving throw or be paralyzed for the duration. This spell has no effect on undead. At the end of each of its turns, the target can make another Wisdom saving throw. On a success, the spell ends on the target.",
    "At Higher Levels. When you cast this spell using a spell slot of 6th level or higher, you can target one additional creature for each slot level above 5th. The creatures must be within 30 feet of each other when you target them."
  ],
  "spellLists": ["bard", "sorcerer", "warlock", "wizard"]
}
